<template>
  <v-container fluid class="ma-4 pa-4">
    <v-row class="mx-4">
      <v-col lg="8">
        <v-row justify="start">
          <v-col>
            <v-row>
              <h1 class="text-h4 mt-3 mb-1 pt-4">
                <v-icon x-large color="primary" class="pb-2">
                  mdi-account-details
                </v-icon>
                {{ $t("generic.user") }}
              </h1>
            </v-row>
            <v-row justify="start" class="py-0">
              <v-col class="px-0 py-0">
                <h3 class="text-h6 my-2">
                  {{ identity.name }}
                </h3>
                <h3 class="text-h6 my-2">
                  {{ $t("generic.email") }} : {{ identity.email }}
                </h3>
                <h3 class="text-h6 my-2">
                  {{ $t("generic.company") }} : {{ identity.company }}
                </h3>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="start">
          <v-col>
            <v-row>
              <h1 class="text-h4 my-4 pt-4">
                <v-icon x-large color="primary" class="pb-2">
                  mdi-tune-vertical-variant
                </v-icon>
                {{ $t("contact.preferences") }}
              </h1>
            </v-row>
            <v-row justify="start">
              <v-col cols="6" class="px-0">
                <v-select
                  v-model="identity.lang"
                  :items="langs"
                  :label="$t('contact.lang')"
                  @change="changeLang"
                  outlined
                  color="primary"
                  success
                ></v-select>
                <v-card class="perso_card">
                  <v-container>
                    <v-row align="center" justify="space-between">
                      <v-col cols="8">
                        <h3>{{ $t("contact.personnalData") }}</h3>
                        <p class="caption">
                          {{ $t("contact.personnalDataDetails") }}
                        </p>
                      </v-col>
                      <v-col cols="4" align="right">
                        <v-btn icon x-large color="primary" to="/about">
                          <v-icon>mdi-security</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="my-4 py-4">
              <v-btn depressed color="primary" @click="logOut">
                {{ $t("generic.logout") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.perso_card {
  border: 2px solid #ca0538;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      langs: ["fr", "en"],
    };
  },
  components: {},
  mounted() {
    if (this.identity.lang) {
      this.$i18n.locale = this.identity.lang;
    }
  },
  computed: {
    ...mapGetters(["identity"]),
  },
  methods: {
    ...mapMutations(["setLang", "resetState", "resetUser"]),
    ...mapActions(["updateProfile"]),
    async changeLang() {
      await this.updateProfile("lang");
      this.setLang(this.identity.lang);
    },
    logOut() {
      this.$router.push("/logout")
    },
  },
};
</script>